import type { RouteRecordRaw } from 'vue-router';

/**
 * 交付管理端路由表 — meta.perm 为菜单级权限码；meta.crumb 为面包屑标题。
 *
 * 群主 seq=464 裁定：所有需求升 P0，第一期全上。
 * `/delivery/orders` 已接入（POST /api/delivery/orders/query 等）。
 * `/pool/*` 抢单管理待下一批次接入。
 *
 * t70：菜单判据码取真表档归一口径下的实际码形（页节点归一为 menu:<页码>，模块/动作节点取原码），
 * 由离线断言 routePermCatalog 钉住；改前三枚抄的是后端样例数据里的码，与真表零交集，
 * 机构侧身份登录后会被一律拦到无权限页。
 */
export const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/LoginView.vue'),
    meta: { public: true, title: '登录' },
  },
  // t122（首登强制改密）：改密出口页。⛔ 不套 DeliveryLayout（拦截期间业务骨架一律不渲染）；
  // 非 meta.public ⇒ 无令牌仍先落登录页；已登录且首登位在场时守卫**只放行本页**。
  {
    path: '/change-password',
    name: 'changePassword',
    component: () => import('@/views/system/ChangePasswordView.vue'),
    meta: { title: '修改初始密码' },
  },
  {
    path: '/',
    component: () => import('@/layouts/DeliveryLayout.vue'),
    children: [
      { path: '', redirect: '/orders' },
      {
        path: 'orders',
        name: 'orders',
        component: () => import('@/views/orders/DeliveryOrderListView.vue'),
        meta: { title: '交付订单', crumb: '交付订单管理', perm: 'menu:order_list', menu: true, menuOrder: 1 },
      },
      {
        path: 'pool',
        name: 'pool',
        component: () => import('@/views/pool/PoolManageView.vue'),
        meta: { title: '抢单管理', crumb: '抢单管理', perm: 'menu:delivery_pool', menu: true, menuOrder: 2 },
      },
      {
        path: 'couriers',
        name: 'couriers',
        component: () => import('@/views/couriers/CourierManageView.vue'),
        meta: { title: '交付员管理', crumb: '交付员管理', perm: 'dagency:staff', menu: true, menuOrder: 3 },
      },
      {
        path: 'forbidden',
        name: 'forbidden',
        component: () => import('@/views/system/ForbiddenView.vue'),
        meta: { title: '无访问权限', public: true },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/system/NotFoundView.vue'),
    meta: { public: true, title: '页面不存在' },
  },
];
